import * as React from 'react'
import { t } from 'ttag'
import { ActivityCard } from '../../components/ActivityCard/ActivityCard'
import { ActivityCardSection } from '../../components/ActivityCard/ActivityCardSection/ActivityCardSection'
import { GoalDto, GoalWithProgress, ProgressType } from '../../services/api.types'
import { convertUTCToLocalDate, getPeriodStringJsx } from './date'
import { getProgressTypeString } from './translations'
import Linkify from 'react-linkify'
import { openUrl } from './routeHelpers'

export const formatDescription = (description: string) => (
  <Linkify
    componentDecorator={(decoratedHref, decoratedText, key) => (
      <a
        key={key}
        href={undefined}
        onClick={() => openUrl(decoratedHref, true)}
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {decoratedText}
      </a>
    )}
  >
    {description}
  </Linkify>
)

export function renderActivityCard(goalsDtoLoading: boolean, singleGoal?: GoalDto, lang?: string) {
  const isGoalSet = !!(
    singleGoal &&
    (singleGoal.stepsGoal || (singleGoal.startDate && singleGoal.endDate) || singleGoal.voucher)
  )

  let status = ''
  if (singleGoal) {
    if (convertUTCToLocalDate(new Date(singleGoal.endDate)).getTime() < new Date().getTime()) {
      status = t`Past`
    } else if (convertUTCToLocalDate(new Date(singleGoal.startDate)).getTime() > new Date().getTime()) {
      status = t`Future`
    } else {
      status = t`Current`
    }
  }

  let className = ''

  // Is Bolt's challenge.
  if (singleGoal && singleGoal.companyId === '95aa8301-348b-427c-9bfa-c445c3451a10') {
    className = 'activity-card--bolt'
  }

  // Is FootBolt's challenge.
  if (singleGoal && singleGoal.companyId === '0f844203-75d7-42a2-a8f5-680c95cffc03') {
    className = 'activity-card--bolt'
  }

  const isCustom = singleGoal
    ? singleGoal.progressType === ProgressType.CUSTOM ||
      singleGoal.progressType === ProgressType.PERSISTENCE_CUSTOM ||
      singleGoal.progressType === ProgressType.PERSISTENCE_CUSTOM_BINARY
    : false

  return (
    <ActivityCard isLoading={goalsDtoLoading} isGoalSet={isGoalSet} className={className}>
      {!isGoalSet || !singleGoal ? (
        <ActivityCardSection content={t`No current goal was found`} type="empty" />
      ) : (
        <>
          {isCustom ? (
            <ActivityCardSection content={singleGoal.title} type="title" activity={singleGoal.progressType} />
          ) : (
            ''
          )}

          {singleGoal.stepsGoal && !isCustom ? (
            <ActivityCardSection
              content={getProgressTypeString(singleGoal as GoalWithProgress)}
              type="goal"
              activity={singleGoal.progressType}
            />
          ) : (
            ''
          )}

          {singleGoal.startDate && singleGoal.endDate && (
            <ActivityCardSection
              content={getPeriodStringJsx(singleGoal.startDate, singleGoal.endDate, lang)}
              type="time"
              status={status}
            />
          )}

          {singleGoal.voucher && <ActivityCardSection content={singleGoal.voucher} type="prize" />}

          {singleGoal.description && (
            <ActivityCardSection content={formatDescription(singleGoal.description)} type="description" />
          )}
        </>
      )}
    </ActivityCard>
  )
}

export function formatNullValues(value: number | null): number {
  return value === null ? 0 : value
}
